/* Menú de celular F&NT
   Reacomoda el cajón de Horizon sin tocar snippets/header-drawer.liquid:
   - Buscador arriba: abre el mismo modal de sugerencias que la lupa
   - Renglón del quiz (¿No sabes por dónde empezar? + haz el quiz)
   - Título "Categorías" y miniatura de producto en cada renglón
   - Nombre de la categoría navegable con el desplegable ya abierto
   - Título "Más" e iconos en Conócenos / Contacto / Quiz / Blog
   - "Mi cuenta" al pie
   v16: se carga con async y arma el menú en cuanto el encabezado existe, sin esperar
   a que termine de cargar toda la página (antes, si se abría el menú muy pronto,
   salía sin buscador, sin quiz y con los banners como miniatura).
   Para revertir: quita las dos líneas de fnt-menu-movil en layout/theme.liquid. */
(function () {
  var CDN = 'https://fntsuplementos.com/cdn/shop/files/';
  // Miniatura por categoría (producto representativo). Las llaves son el handle
  // del menú, que no siempre es igual al de la colección: proteinas/proteina, combos/kits.
  var THUMBS = {
    'proteina': '3500G-VAINILLA.png',
    'proteinas': '3500G-VAINILLA.png',
    'combos': '2000-NUEZ.png',
    'kits': '2000-NUEZ.png',
    'capsulas': 'ARGININE_CITRULINE.png',
    'creatinas': 'CREATINA-FRONTAL.png',
    'energeticos-y-pre-entrenos': '600-BLUEBERRIES.png',
    'vasodilatadores': '1000-UVA.png',
    'quema-grasa-y-metabolismo': '600-TEVERDE.png',
    'aminoacidos-y-recuperacion': 'BCAAS-FRONTAL.png'
  };

  // Handle real de la colección cuando no coincide con el del menú.
  var COLL = { 'proteinas': 'proteina', 'proteina': 'proteina', 'combos': 'kits', 'kits': 'kits' };

  // Iconos de los enlaces secundarios, por palabra del texto
  var ICONS = [
    { match: 'conoce', path: '<path d="M12 3l9 9-9 9-9-9 9-9z"/>' },
    { match: 'blog', path: '<path d="M4 5h16M4 10h16M4 15h10"/>' },
    { match: 'contacto', path: '<path d="M4 5h4l2 5-2.5 1.5a11 11 0 005 5L14 14l5 2v4h-1A15 15 0 014 6V5z"/>' },
    { match: 'quiz', path: '<circle cx="12" cy="12" r="9"/><path d="M9.5 9.5a2.5 2.5 0 015 .5c0 1.7-2.5 2-2.5 4M12 17.5h.01"/>' },
    { match: 'mayoreo', path: '<path d="M12 3l8 4v6c0 4.5-3.2 8.2-8 9-4.8-.8-8-4.5-8-9V7z"/>' }
  ];

  function icon(path, size) {
    return '<svg viewBox="0 0 24 24" width="' + (size || 18) + '" height="' + (size || 18) + '" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + path + '</svg>';
  }

  // Cierra el cajón del menú (su <dialog> o el botón de cerrar)
  function closeDrawer(drawer) {
    var dialog = drawer.querySelector('dialog[open]');
    if (dialog && typeof dialog.close === 'function') {
      try { dialog.close(); return; } catch (e) {}
    }
    var btn = drawer.querySelector('[on\\:click*="close"]');
    if (btn) btn.click();
  }

  // Abre el buscador con sugerencias: el mismo modal que la lupa del encabezado.
  // 1) usa el botón de la lupa si está en el DOM, 2) llama al componente
  // dialog-component#search-modal, 3) si nada existe, va a /search.
  function openSearchModal() {
    var modal = document.getElementById('search-modal');
    var trigger = document.querySelector(
      '[on\\:click="search-modal/showDialog"], [on\\:click*="search-modal"], .search-modal__button'
    );
    if (trigger) {
      trigger.click();
    } else if (modal && typeof modal.showDialog === 'function') {
      modal.showDialog();
    } else if (modal && modal.querySelector('dialog') && typeof modal.querySelector('dialog').showModal === 'function') {
      modal.querySelector('dialog').showModal();
    } else {
      window.location.href = '/search';
      return;
    }
    // El campo recibe el cursor en cuanto el modal termina de abrir
    setTimeout(function () {
      var input = document.querySelector('#search-modal input[type="search"], #search-modal input');
      if (input) input.focus();
    }, 180);
  }

  // El id del renglón trae el handle de la categoría (HeaderDrawer-proteinas).
  // Si no lo trae, se usa su propio enlace; nunca el de un producto hijo.
  function handleFromItem(item) {
    var id = item.getAttribute('id') || '';
    if (id.indexOf('HeaderDrawer-') === 0) {
      var handle = id.replace('HeaderDrawer-', '');
      if (handle && handle.indexOf('-') !== 0) return handle;
    }
    if (item.tagName === 'A') {
      var m = (item.getAttribute('href') || '').match(/\/collections\/([^\/?#]+)/);
      if (m) return m[1];
    }
    return '';
  }

  // Cada categoría es un <summary> sin enlace propio, así que el nombre no lleva
  // a la colección. Primer toque: abre el desplegable. Segundo toque en el nombre:
  // navega a la página de la categoría. El chevron siempre abre y cierra.
  function linkCategories(drawer) {
    drawer.querySelectorAll('.menu-drawer__menu-item--mainlist').forEach(function (item) {
      var summary = item.tagName === 'SUMMARY' ? item : item.querySelector('summary');
      if (!summary || summary.dataset.fntCat) return;
      var details = summary.closest('details');
      if (!details) return;
      var handle = handleFromItem(item);
      if (!handle) return;

      var href = '/collections/' + (COLL[handle] || handle);
      summary.dataset.fntCat = '1';
      summary.setAttribute('data-fnt-href', href);

      summary.addEventListener('click', function (e) {
        if (!details.open) return;
        var t = e.target;
        if (t && t.closest && t.closest('svg, .icon, .fnt-mmv__toggle')) return;
        e.preventDefault();
        e.stopPropagation();
        window.location.href = href;
      });
    });
  }

  function decorate(drawer) {
    if (drawer.dataset.fntMmv) return;

    var nav = drawer.querySelector('.menu-drawer__navigation');
    var list = drawer.querySelector('.menu-drawer__menu.has-submenu');
    // Si el cajón aún no trae su contenido, no se marca: se reintenta en el siguiente boot
    if (!nav || !list) return;
    drawer.dataset.fntMmv = '1';

    // Buscador: abre el modal de sugerencias, no la página /search.
    // Se queda como enlace para conservar el estilo de fnt-menu-movil.css.
    var search = document.createElement('a');
    search.className = 'fnt-mmv__search';
    search.href = '/search';
    search.setAttribute('role', 'button');
    search.innerHTML = icon('<circle cx="11" cy="11" r="7"></circle><path d="M20 20l-3.5-3.5"></path>') + '<span>Buscar producto</span>';
    search.addEventListener('click', function (e) {
      e.preventDefault();
      closeDrawer(drawer);
      setTimeout(openSearchModal, 120);
    });
    nav.insertBefore(search, list);

    // Renglón del quiz
    var quiz = document.createElement('a');
    quiz.className = 'fnt-mmv__quiz';
    quiz.href = '/pages/quiz';
    quiz.innerHTML =
      '<span class="fnt-mmv__quiz-body">' +
      '<span class="fnt-mmv__quiz-title">¿No sabes por dónde empezar?</span>' +
      '<span class="fnt-mmv__quiz-text">Haz el quiz: 5 preguntas y te sugerimos qué tomar</span>' +
      '</span>' + icon('<path d="M9 5l7 7-7 7"/>');
    nav.insertBefore(quiz, list);

    // Título Categorías
    var head = document.createElement('div');
    head.className = 'fnt-mmv__head';
    head.textContent = 'Categorías';
    nav.insertBefore(head, list);

    // Miniatura de producto en cada categoría
    drawer.querySelectorAll('.menu-drawer__menu-item--mainlist').forEach(function (item) {
      var handle = handleFromItem(item);
      var img = item.querySelector('.menu-drawer__collection-img');
      var file = THUMBS[handle];
      if (img && file) {
        img.setAttribute('src', CDN + file + '?width=160');
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.removeAttribute('width');
        img.removeAttribute('height');
        img.setAttribute('loading', 'lazy');
      }
    });

    // Título Más + iconos en los enlaces secundarios
    var comp = drawer.querySelector('.menu-drawer__complementary-nav');
    if (comp) {
      var head2 = document.createElement('div');
      head2.className = 'fnt-mmv__head';
      head2.textContent = 'Más';
      comp.parentNode.insertBefore(head2, comp);

      comp.querySelectorAll('.menu-drawer__complementary-link').forEach(function (link) {
        if (link.querySelector('.fnt-mmv__ico')) return;
        var txt = (link.textContent || '').toLowerCase();
        var found = ICONS.filter(function (i) { return txt.indexOf(i.match) > -1; })[0];
        var span = document.createElement('span');
        span.className = 'fnt-mmv__ico';
        span.innerHTML = icon(found ? found.path : '<circle cx="12" cy="12" r="8"/>');
        link.insertBefore(span, link.firstChild);
      });
    }

    // Mi cuenta al pie
    var utility = drawer.querySelector('.menu-drawer__utility-links');
    if (utility && !utility.querySelector('.fnt-mmv__account')) {
      var account = document.createElement('a');
      account.className = 'fnt-mmv__account';
      account.href = '/account';
      account.innerHTML = icon('<circle cx="12" cy="8" r="4"></circle><path d="M4 21c1.5-4 4.5-6 8-6s6.5 2 8 6"></path>') + '<span>Mi cuenta</span>';
      utility.appendChild(account);
    }
  }

  function boot() {
    document.querySelectorAll('[data-header-drawer]').forEach(function (drawer) {
      decorate(drawer);
      linkCategories(drawer);
    });
  }

  // El encabezado ya está completo cuando existe #MainContent (va justo después en el
  // layout). Con async el script puede correr antes: se espera solo a ese punto, no a
  // que termine de cargar toda la página.
  function headerReady() {
    return document.readyState !== 'loading' || !!document.getElementById('MainContent');
  }

  if (headerReady()) {
    boot();
  } else {
    var done = false;
    var finish = function () {
      if (done) return;
      done = true;
      if (obs) obs.disconnect();
      boot();
    };
    var obs = null;
    if (typeof MutationObserver === 'function') {
      obs = new MutationObserver(function () {
        if (document.getElementById('MainContent')) finish();
      });
      obs.observe(document.documentElement, { childList: true, subtree: true });
    }
    document.addEventListener('DOMContentLoaded', finish);
  }
  // Respaldo: si algo volvió a pintar el encabezado, se arma otra vez
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
